import { entityTypeNameFor } from "@shapeable/utils";
import { useEntityTypes } from "./use-entity-types";
export var useEntityTypeForEntity = function (entity) {
  // Get the entity types from platform data
  var entityTypes = useEntityTypes();
  // Get the type name of the enitity passed in
  var entityTypeName = entityTypeNameFor(entity);
  if (entityTypeName) {
    return entityTypes.find(function (entityType) {
      return entityType.internalName === entityTypeName || entityType.name === entityTypeName;
    });
  }
  return null;
};